import script from "./TableShop.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableShop.vue?vue&type=script&setup=true&lang=ts"

import "./TableShop.vue?vue&type=style&index=0&id=65bc3f0b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65bc3f0b"]])

export default __exports__